import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Text,
  Heading,
  Button,
  VStack,
  HStack,
  Divider,
  useToast,
  Image,
  useDisclosure,
} from '@chakra-ui/react';
import html2pdf from 'html2pdf.js';
import logo from '../../assets/eba836181a8bb389cc40f37585eec6ae.png';
import { useParams } from 'react-router-dom'; 
import CustomSpinner from './CustomSpinner';
import Api from '../../api/ApiUrl'
import { useQuery, useMutation, useQueryClient } from 'react-query';
import UserService from '../../services/UserService'; 
import Cookies from 'js-cookie';
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const Billing = () => {
  const { isOpen: isDepositOpen, onOpen: onDepositOpen, onClose: onDepositClose } = useDisclosure();
  const userCookie = Cookies.get('user');  
  const { id } = useParams(); 


  const adminId = userCookie ? JSON.parse(userCookie)?._id ?? '' : '';
  const [isActionLoading, setIsActionLoading] = useState(false);

  const depositMutation = useMutation(
    ({ userId, amount, adminId }) => UserService.deposit(userId, amount, adminId,id,1),
    {
      onMutate: () => setIsActionLoading(true),
      onSuccess: () => {
        toast({
          title: 'Refund successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        // queryClient.invalidateQueries(['user', userId]);
        window.location.reload();
        onDepositClose();
      },
      onError: (error) => {
        toast({
          title: 'Error occurred',
          description: error.response?.data?.message || 'Unable to process refund',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      },
      onSettled: () => setIsActionLoading(false),
    }
  );
  
//   const [billData, setBillData] = useState([]);
  const toast = useToast();
  const fetchBillData = async (id) => {
    const response = await axios.get(`${Api}/api/v1/mylots/a/${id}?status=winner`,config);
    return response.data;
  };
  const { data, error, isLoading } = useQuery(['billData', id], () => fetchBillData(id), {
    onError: () => {
      toast({
        title: 'Error',
        description: 'فشل في جلب الفواتير.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    },
  });


  const downloadBill = (bill) => {
    const element = document.getElementById(`bill-${bill.userPhone}`,config);
    const opt = {
      margin: 0,
      filename: `bill-${bill.userPhone}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
    };

    // Hide buttons before generating PDF
    const buttons = document.getElementsByClassName('no-print');
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].style.display = 'none';
    }

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .then(() => {
        // Show buttons again after PDF is generated
        for (let i = 0; i < buttons.length; i++) {
          buttons[i].style.display = 'block';
        }
      });
  };

  const printBill = (bill) => {
    const element = document.getElementById(`bill-${bill.subcategoryId}`);
    const newWindow = window.open();
    newWindow.document.write(element.outerHTML);
    newWindow.print();
    newWindow.close();
  };

  if (isLoading) return <CustomSpinner size="xl" />;
  if (error) return <Text color="red.500">Error: {error.message}</Text>;

  const billData = data.itemDetails;
  const calculateTotalBeforeDeposit = (items) => {
    return items.reduce((total, item) => total + item.totalPaid, 0);
  };
  const calculateTotalBeforeCommisson = (items) => {
    return items.reduce((total, item) => total + item.item.startPrice, 0);
  };
  const calculateTotalCommissions = (items) => {
    return items.reduce((total, item) => 
      total + item.commission1 + item.commission2 + item.commission3, 0);
  };
  return (
    <Box
      position="relative"
      maxW="1000px"
      mx="auto"
      p={5}
      direction="rtl"
    >
      {billData.map((bill, index) => (
        <Box
          key={index}
          id={`bill-${bill.userPhone}`}
          borderWidth="1px"
          borderRadius="lg"
          p={6}
          mb={8}
          boxShadow="xl"
          bg="white"
          position="relative"
        >
          {/* Background Text */}
          <Text
            fontSize="150px"
            fontWeight="bold"
            color="blackAlpha.200"
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            zIndex={-1}
            opacity={0.1}
            textAlign="center"
          >
            مصر للمزادات
          </Text>

          {/* Logo */}
          <Box textAlign="center" mb={10}>
            <Image
              src={logo} // Replace with your logo URL
              alt="شعار مزادات مصر"
              width="200px"
              mb={5}
            />
            <Heading as="h1" size="md" color="red.500">
            مصر للمزادات
            </Heading>
          </Box>

          <VStack align="end" spacing={4}>
            <Heading as="h3" size="md" color="gray.800">
        المزاد تابع الى : {bill.subcategoryName}
            </Heading>

            <Text className='flex'>
            {bill.userName} <strong>: اسم المتزايد</strong> 
            </Text>
            <Text className='flex'>
            {bill.userPhone} <strong> : الهاتف</strong> 
            </Text>
            <Text className='flex'>
              {bill.categoryName} <strong>: التصنيف</strong>
            </Text>
            <Text className='flex'>
             <span>ج.م</span>{bill.deposit}<strong>: التامين الابتدائي</strong>
            </Text>
            <Text className='flex'>
            <span>ج.م</span>{calculateTotalBeforeCommisson(bill.items)}<strong>: سعر اللوط / اللوطات</strong>
            </Text>
            <Text className='flex'>
            <span>ج.م</span>{calculateTotalCommissions(bill.items)}<strong>: إجمالي الرسوم</strong> 
            </Text>
            <Text className='flex'>
            <span>ج.م</span>{calculateTotalBeforeDeposit(bill.items)}<strong>: اجمالي الترسيه شامل الرسوم</strong> 
            </Text>
            <Text className='flex'>
            <span>ج.م</span>{bill.totalAmount === 0 
    ? `${calculateTotalBeforeDeposit(bill.items)} - ج.م`
    : 
    `${calculateTotalBeforeDeposit(bill.items)-bill.deposit}
    `
  }<strong>: اجمالي المطلوب سداده بعد خصم التامين</strong>
  
</Text>

            {bill.deposit>calculateTotalBeforeDeposit(bill.items)?        <Text>
              {/* <strong>إجمالي المبلغ بعد خصم التامين:</strong> {bill.totalAmount} ج.م */}
              <strong>إجمالي المبلغ المسترد للمحفظة:</strong> {bill.deposit-calculateTotalBeforeDeposit(bill.items)}ج.م

            </Text>:""}
            {/* <Text>
              <strong>مدفوع:</strong> {bill.payed ? 'نعم' : 'لا'}
            </Text> */}
            <Text>
  <strong>مدفوع:</strong>{" "}
  {bill.deposit - calculateTotalBeforeDeposit(bill.items) >= 0 || bill.payed 
    ? "نعم" 
    : "لا"}
</Text>
            <Divider />

            <Heading as="h3" size="sm">
            : تفاصيل اللوطات 
            </Heading>

            {bill.items.map((item, idx) => (
              <Box
                key={idx}
                borderWidth="1px"
                borderRadius="md"
                p={4}
                w="100%"
                bg="gray.50"
              >
                <HStack spacing={4} align="flex-end" justify="space-between">
                  <Image
                    src={`${Api}/${item.item.coverphoto.path}`}
                    alt={item.item.name}
                    boxSize="100px"
                    objectFit="cover"
                    borderRadius="md"
                  />
                  <VStack align="end" spacing={2}>
                  <Text 
  style={{ unicodeBidi: 'plaintext', direction: 'rtl' }}
>
  <strong>رقم اللوط:</strong> {item.item.name}
</Text>
                    <Text>
                      <strong>سعر اللوط:</strong> {item.item.startPrice} ج.م
                    </Text>
               
                    {/* <Text>
                      <strong>الحالة:</strong> {item.status}
                    </Text> */}
                    <Text>
                      <strong>الرسوم:</strong>{' '}
                      {item.commission1 + item.commission2 + item.commission3}{' '}
                      ج.م
                    </Text>
                    <Text>
                      <strong>إجمالي الترسيه شامل الرسوم:</strong> {item.totalPaid} ج.م
                    </Text>
                  </VStack>
                </HStack>
              </Box>
            ))}

          {bill.deposit > calculateTotalBeforeDeposit(bill.items) && (
          <Text>
          <strong>إجمالي المبلغ المسترد للمحفظة:</strong> {bill.deposit - calculateTotalBeforeDeposit(bill.items)} ج.م
        </Text>
          )}
          {/* Refund Button */}
          {bill.deposit > calculateTotalBeforeDeposit(bill.items) && (
            <Button
            isDisabled={bill.refund}

              colorScheme={bill.refund?"red":"green"}
              className="no-print"
              onClick={() => depositMutation.mutate({
                userId: bill.userid, 
                amount: bill.deposit - calculateTotalBeforeDeposit(bill.items), 
                adminId: adminId 
              })}
            >
         {bill.deposit ?'Refunded':'Refund Deposit'}
            </Button>
          )}

            {/* Buttons (hidden in PDF) */}
            <HStack spacing={4} className="no-print" dir="rtl">
              
              <Button
                colorScheme="blue"
                onClick={() => downloadBill(bill)}
                size="sm"
              >
                تحميل كملف PDF
              </Button>
              {/* <Button
                colorScheme="green"
                onClick={() => printBill(bill)}
                size="sm"
              >
                طباعة
              </Button> */}
            </HStack>
          </VStack>
        </Box>
      ))}
    </Box>
  );
};

export default Billing;
